import { formatRowCount, groupByHint, isGroupByRecommended } from "../../logic/services/reportBuilderSummary.js";

function InspectorRow({ label, value, c, accent }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", gap: 8, fontSize: 12 }}>
      <span style={{ color: c.sub }}>{label}</span>
      <span style={{ fontWeight: 600, color: accent ?? c.text, textAlign: "right" }}>{value}</span>
    </div>
  );
}

export function ReportBuilderInspector({ config, dataset, queryPreview, estimate, estimateLoading, c, A, dark }) {
  const groupHint = groupByHint(config);
  const groupRecommended = isGroupByRecommended(config);

  return (
    <aside
      style={{
        width: 300,
        flexShrink: 0,
        display: "flex",
        flexDirection: "column",
        gap: 12,
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      <div
        style={{
          background: c.card,
          border: `1px solid ${c.cardBdr}`,
          borderRadius: 12,
          padding: 14,
          boxShadow: dark ? "0 8px 24px rgba(0,0,0,.2)" : "0 8px 24px rgba(15,23,42,.06)",
        }}
      >
        <h3 style={{ margin: "0 0 10px", fontSize: 11, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: c.sub }}>
          Report summary
        </h3>
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <InspectorRow label="Dataset" value={dataset?.name ?? "—"} c={c} />
          <InspectorRow label="Filters" value={String(config.filters.length)} c={c} />
          <InspectorRow
            label="Group by"
            value={config.groupBy.length ? String(config.groupBy.length) : "None"}
            c={c}
            accent={groupRecommended ? A : undefined}
          />
          <InspectorRow label="Metrics" value={String(config.metrics.length)} c={c} />
          {groupRecommended ? (
            <p style={{ margin: 0, fontSize: 11, color: A, lineHeight: 1.45 }}>{groupHint}</p>
          ) : null}
          <InspectorRow label="Visual" value={config.visualization} c={c} />
        </div>
      </div>

      <div
        style={{
          background: `${A}0c`,
          border: `1px solid ${A}28`,
          borderRadius: 12,
          padding: 14,
        }}
      >
        <h3 style={{ margin: "0 0 10px", fontSize: 11, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: c.sub }}>
          Query cost
        </h3>
        {estimateLoading || !estimate ? (
          <p style={{ margin: 0, fontSize: 12, color: c.sub }}>Calculating…</p>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <InspectorRow label="Rows" value={formatRowCount(estimate.rows)} c={c} accent={A} />
            <InspectorRow label="Scan" value={estimate.scan} c={c} accent={A} />
            <InspectorRow label="Runtime" value={`${estimate.runtimeSec}s`} c={c} accent={A} />
            <InspectorRow label="Cost units" value={String(estimate.costUnits)} c={c} accent={A} />
          </div>
        )}
      </div>

      <div
        style={{
          background: c.card,
          border: `1px solid ${c.cardBdr}`,
          borderRadius: 12,
          padding: 14,
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <h3 style={{ margin: "0 0 8px", fontSize: 11, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: c.sub }}>
          SQL preview
        </h3>
        <pre
          style={{
            margin: 0,
            flex: 1,
            overflow: "auto",
            fontSize: 11,
            lineHeight: 1.55,
            fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace",
            color: c.mid,
            whiteSpace: "pre-wrap",
            wordBreak: "break-word",
          }}
        >
          {queryPreview}
        </pre>
      </div>
    </aside>
  );
}
